export default __webpack_public_path__ + "static/media/greater_than.e80dd3ef.svg";